// import { useEffect } from "react";
// import { Controls, ZoomControl, ScaleLineControl, AttributionControl } from "../../Controls";
// import { LegendControl } from "../../Legend/LegendControl";
// export default function GetControls({
//   showZoomControl = true,
//   showLegend = true,
//   showScaleLine = true,
//   showAttribute = true,
// }) {
//   useEffect(() => {
//     //console.log("common called and, show legend is :", showLegend);
//   }, [showLegend]);
//   return (
//     <Controls>
//       {showZoomControl && <ZoomControl />}
//       {showScaleLine && <ScaleLineControl />}
//       {showAttribute && <AttributionControl />}
//       {showLegend && <LegendControl />}
//     </Controls>
//   );
// }

////////////
import { useEffect } from "react";
import { Controls, ZoomControl, ScaleLineControl, AttributionControl } from "../../Controls";
import { LegendControl } from "../../Legend/LegendControl";
import { ParkInfoControl } from "../../ParkInfo/ParkInfoControl";

export default function GetControls({
  showZoomControl = true,
  showLegend = true,
  showScaleLine = true,
  showAttribute = true,
  showParkInfo = false,
  selectedPark = null, // Add selectedPark prop
}) {
  useEffect(() => {
    console.log("GetControls - showParkInfo:", showParkInfo, "selectedPark:", selectedPark);
  }, [showParkInfo, selectedPark]);

  return (
    <Controls>
      {showZoomControl && <ZoomControl />}
      {showScaleLine && <ScaleLineControl />}
      {showAttribute && <AttributionControl />}
      {showLegend && <LegendControl />}
      {showParkInfo && <ParkInfoControl selectedPark={selectedPark} />}
    </Controls>
  );
}